export default {
  namespaced: true,
  state: {
    addressId: null,
  },
  getters: {
    getAddressIdJustAfterUpSert(state) {
      return state.addressId
    },
  },
  mutations: {
    setAddressId(state, newData) {
      state.addressId = newData
    },
    resetAddressId(state) {
      state.addressId = null
    },
  },
}
